export const theme = {
    primary: "#df2826",
    primaryDark: "#981b1e",
    text: "#292828",
    grey: "#818285",
    darkGrey: "#424242",
    lightGrey: "#c9cfd7",
    background: "#f5f5f5",
    gold: "#fcb040",
}
